import React from "react";
import { Switch } from "react-router-dom";
import Route from "./route";
import ResetPassword from "../components/ResetPassword/ResetPassword";
import RememberPassword from "../components/RememberPassword/RememberPassword";

import PageNotFound from "../components/PageNotFound/PageNotFound.jsx";
import GeradorDePropostas from "../components/GeradorDePropostas";
import TelaLogin from "../components/Login/LoginUsuario";
import Success from "../components/Success/Success";
import Register from "../components/Register/Register.js";
import Grid from "../components/Grid/Grid.js";
import Create from "../components/Grid/Grid.js";
import Contato from "../components/Contato/Contato.js";
import NotificationsPage from "../components/Notifications/NotificationsPage";

const Routes: React.FC = () => (
  <Switch>
    <Route exact path="/grid" component={Grid} isPrivateAndPublic />
    <Route path="/login" component={TelaLogin} isPrivateAndPublic />
    <Route exact path="/" component={Create} isPrivate />
    <Route exact path="/contato" component={Contato} isPrivateAndPublic />
    <Route path="/GPCR" component={GeradorDePropostas} isPrivateAndPublic />
    <Route
      path="/rememberpassword"
      component={RememberPassword}
      isPrivateAndPublic
    />
    <Route path="/success/" component={Success} isPrivateAndPublic />
    <Route path="/register/" component={Register} isPrivateAndPublic />
    <Route
      path="/resetpassword/:id"
      component={ResetPassword}
      isPrivateAndPublic
    />
    <Route
      exact
      path="/notifications"
      component={NotificationsPage}
      isPrivateAndPublic
    />
    <Route path="*" component={PageNotFound} isPrivateAndPublic />
  </Switch>
);

export default Routes;
